import { transformFolder, transformUserData } from '../../services/UserService/transforms';
export class UserService {
    #requestClient;
    #storeClient;
    constructor(requestClient, storeClient) {
        this.#requestClient = requestClient;
        this.#storeClient = storeClient;
    }
    async getMe() {
        const { partnerId, serial } = this.#storeClient.options;
        const response = await this.#requestClient.graphQlSdk.getUser({
            device: { partnerId, serial },
        });
        const userData = transformUserData(response);
        this.#storeClient.userData = userData;
        return userData;
    }
    toggleFavorite({ guideId, favorite }) {
        return this.#requestClient.fetch({
            url: `${this.#storeClient.options.domains.opml}/favorites.ashx`,
            params: {
                c: favorite ? 'add' : 'remove',
                favoriteId: guideId,
                id: guideId,
            },
        });
    }
    addFolder(name) {
        return this.#requestClient.fetch({
            url: `${this.#storeClient.options.domains.opml}/favorites.ashx`,
            params: {
                c: 'addFolder',
                name,
                transform: transformFolder,
            },
        });
    }
    deleteFolder(id) {
        return this.#requestClient.fetch({
            url: `${this.#storeClient.options.domains.opml}/favorites.ashx`,
            params: {
                c: 'removeFolder',
                folderId: id,
            },
        });
    }
}
